import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../../../../constants/common'
import {
  useAsyncCallback,
  useInfiniteItemsFetchData,
} from '../../../../../hooks'
import { getRequestProfileOpenActivities } from '../../RequestProfileOpenActivities.api'
import { REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE } from '../../RequestProfileOpenActivities.constants'
import { getRequestProfileOpenActivitiesResponseItems } from '../../RequestProfileOpenActivities.utils'

export function useRequestProfileOpenActivities(requestId) {
  const [displayCount, setDisplayCount] = useState(
    REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE
  )

  const apiParams = { requestId }

  const {
    items,
    loadingInitial,
    loadingMore,
    loadInitial,
    loadMore,
    totalCount,
  } = useInfiniteItemsFetchData({
    apiParams,
    getData: getRequestProfileOpenActivities,
    getDataItems: getRequestProfileOpenActivitiesResponseItems,
    withPagination: true,
  })

  useEffect(() => {
    if (requestId) {
      loadInitial()
    }
  }, [requestId])

  const loadedItems = items || EMPTY_LIST

  function handleShowMore() {
    if (displayCount < loadedItems.length) {
      setDisplayCount(
        count => count + REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE
      )

      return
    }

    if (loadedItems.length < totalCount) {
      loadMore()?.then(nextItems => {
        if (nextItems) {
          setDisplayCount(
            count => count + REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE
          )
        }
      })
    }
  }

  function handleShowLess() {
    setDisplayCount(REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE)
  }

  const handleReload = useAsyncCallback(() => {
    setDisplayCount(REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE)

    return loadInitial()
  }, [loadInitial])

  const visibleItems = loadedItems.slice(0, displayCount)
  const isAllShown = displayCount >= totalCount

  return {
    handleReload,
    handleShowLess,
    handleShowMore,
    isAllShown,
    isLoading: loadingInitial,
    isLoadingMore: loadingMore,
    total: totalCount,
    visibleItems,
  }
}
